module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page-w720.1b2c16f1.jpg";